<div class="cec__module">
	<div class="upsell-modal">
		<div class="upsell__inner cec__form">
			<p [innerHTML]='message' class="text-black"></p>
			<button class="btn--primary btn--purple yesUpsellPackageType" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
			<button class="noUpsellPackageType" (click)="onCancelClick()" tabindex="-1">{{cancelButtonText}}</button>
		</div>
	</div>
</div>
